import React, { useState } from 'react';

import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { ROUTES } from '../../const/routes.const';
import { useButtons } from '../../hooks/data/buttons.hook';
import { Button, BUTTON_TYPES } from '../Button';
import { Logo } from '../Logo';
import { LandingPageProps } from './LandingPage.types';

export const LandingPage: React.FC<LandingPageProps> = ({ handleOnClick }) => {
	const [pictureNumber, setPictureNumber] = useState(1);

	const { buttonClose } = useButtons();

	const handleClickCarousel = (): void => {
		if (pictureNumber < 4) {
			setPictureNumber(pictureNumber + 1);
			return;
		}

		setPictureNumber(1);
	};

	return (
		<section className="c-landing-page u-bg-primary">
			<header className="c-landing-page__header c-logo--small">
				<span className="u-hide-visually">Raf Simons</span>
				<Link
					to={ROUTES.HOME}
					onClick={handleOnClick}
					className="c-link c-link--none">
					<Logo />
				</Link>
			</header>
			<div className="c-landing-page__carousel" onClick={handleClickCarousel}>
				{pictureNumber === 1 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/1.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{pictureNumber === 2 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/2.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{pictureNumber === 3 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/3.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
				{pictureNumber === 4 && (
					<StaticImage
						loading="eager"
						placeholder="none"
						objectFit="contain"
						src="../../assets/landingPageImages/4.jpg"
						alt=""
						className="c-landing-page__image"
					/>
				)}
			</div>
			<footer className="c-landing-page__footer">
				<Button
					label={buttonClose?.label}
					accessibilityLabel={buttonClose?.accessibilityLabel}
					type={BUTTON_TYPES.MEDIUM}
					onClickButton={handleOnClick}
					className="u-color-secondary c-button--contrast-hover"
				/>
			</footer>
		</section>
	);
};
